import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlarmService {
  private currentAudio: HTMLAudioElement | null = null;
  private isEmergencyPlaying: boolean = false;
  public emergencyAlertCounter = signal(0);
  public filesCounter = signal(0);
  public showEmergencyModal = signal(false);
  constructor() {}

  setEmergencyAlertsCounter() {
    this.emergencyAlertCounter.update((count) => count + 1);
    this.playEmergencyAlert('../../assets/danger_alarm.mp3');
  }
  setFilesCounter() {
    this.filesCounter.update((count) => count + 1);
    this.playNotification('../../assets/notification_sound.mp3');
  }

  resetFileCounter() {
    this.filesCounter.set(0);
  }
  resetEmergencyAlertCounter() {
    this.emergencyAlertCounter.set(0);
  }

  playNotification(soundUrl: string): void {
    if (this.isEmergencyPlaying) {
      return;
    }
    this.playSound(soundUrl, 0.6);
  }

  playEmergencyAlert(soundUrl: string): void {
    if (this.currentAudio) {
      this.stopCurrentAudio();
    }
    this.showEmergencyModal.set(true);
    this.isEmergencyPlaying = true;
    this.playSound(soundUrl, 0.1, () => {
      this.isEmergencyPlaying = false;
    });
  }
  stopEmergencyAlertSound(): void {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.showEmergencyModal.set(false);
      this.currentAudio.currentTime = 0;
      this.resetEmergencyAlertCounter();
      this.currentAudio = null;
      this.isEmergencyPlaying = false;
    }
  }

  private playSound(
    soundUrl: string,
    volume: number,
    onEndedCallback?: () => void
  ): void {
    this.stopCurrentAudio();

    this.currentAudio = new Audio(soundUrl);
    this.currentAudio.volume = volume;
    this.currentAudio.play();

    if (onEndedCallback) {
      this.currentAudio.addEventListener('ended', onEndedCallback);
    }

    this.currentAudio.addEventListener('ended', () => {
      this.currentAudio = null;
    });
  }

  private stopCurrentAudio(): void {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
    }
  }
}
